var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"particle-background",attrs:{"id":"particles-js"}})
}
var staticRenderFns = []

export { render, staticRenderFns }